import { render, staticRenderFns } from "./carousel.edit.vue?vue&type=template&id=29ad8bd3&scoped=true"
import script from "./carousel.edit.vue?vue&type=script&lang=js"
export * from "./carousel.edit.vue?vue&type=script&lang=js"
import style0 from "./carousel.edit.vue?vue&type=style&index=0&id=29ad8bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad8bd3",
  null
  
)

export default component.exports